// extracted by mini-css-extract-plugin
export var container = "_rn-0";
export var dotAnimation = "_rn-2";
export var dotsLoading = "_rn-1";